import React from 'react';
import { HL7Detail } from './hl7-detail';
import { ClaimDataEmbeddedPanel } from './claim-data-detail-embedded';
import { IClaimDataDetailProps } from './claim-data-detail.types';
import { isClaimDataHl7Message } from './claim-data-detail.utils';

/**
 * Claim data detail panel for JSON claim payload timeline events.
 */
export const ClaimDataDetail: React.FunctionComponent<IClaimDataDetailProps> = ({
    claimData,
    embedded = false,
    appType = 'provider',
    num,
    label,
}) => {
    if (embedded) {
        return <ClaimDataEmbeddedPanel claimData={claimData} embedded num={num} label={label} />;
    }

    return <HL7Detail hl7Message={claimData} appType={appType} />;
};

export { isClaimDataHl7Message } from './claim-data-detail.utils';
